import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Multi-line text input styled with the design tokens; the Input primitive's twin, sized by its `rows` prop.
 *
 * @category Forms
 */
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      // `text-base md:text-sm` mirrors Input, and the 16px half is functional,
      // not cosmetic: iOS Safari auto-zooms the page whenever a focused field
      // computes under 16px, and it does not zoom back out on blur. Every
      // bespoke textarea in the app predated this primitive and hardcoded
      // text-sm, so all of them zoomed on a phone (found on-device 2026-08-21).
      // Deliberately carries no min-height: call sites size themselves with
      // `rows`, and adding one here would resize all five migrated fields.
      className={cn(
        "flex w-full rounded-md border border-input bg-background px-3 py-2 text-base placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/25 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
